import { c as _c } from "react/compiler-runtime";
import SearchIcon from '@mui/icons-material/Search';
export const Search = t0 => {
  const $ = _c(2);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick) {
    t1 = <SearchIcon aria-label="Search Icon" onClick={onClick} />;
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};